import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  BgBomCategory,
  BgBomItem,
  BgBomModel,
  BgBomSubCategory,
  BomType,
} from 'src/app/shared/models/bg.model';

import { BgBomGroupedSubCategory } from './../../../../shared/models/bg.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { PdfService } from 'src/app/shared/services/pdf.service';
import { Tab } from 'src/app/shared/models/tab.model';
import { ProjectModel } from 'src/app/shared/models/projectModel';
import { NgbDropdownConfig, NgbModal, Placement } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, filter } from 'rxjs';
import { BackendApiService } from 'src/app/shared/services/backend-api.service';
import { BomCalculatorService } from 'src/app/shared/services/bom-calculator.service';
import { BomItemService } from 'src/app/shared/services/bom-item.service';
import { DocumentUnavailableDialogComponent } from 'src/app/shared/components/document-unavailable-dialog/document-unavailable-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommercialOffersService } from 'src/app/shared/services/commercial-offers.service';
import { setIsLoading } from 'src/app/shared/components/app-loading-overlay/app-loading-overlay.component';
import { SheetSizesDictionary } from './models.model';
import { BgModelHelper } from 'src/app/shared/helpers/bg-model-helper';
 @Component({
  selector: 'app-bom-table',
  templateUrl: './bom-table.component.html',
  styleUrls: ['./bom-table.component.scss'],
  providers: [NgbDropdownConfig],
})
export class BomTableComponent implements OnInit {
  @Input() data?: BgBomModel;
  @Input() model?: ProjectModel;
  selectedCategory = new BehaviorSubject<BgBomCategory | undefined>(undefined);
  sortedCategories?: BgBomCategory[];

  BomType = BomType;
  BgModelHelper = BgModelHelper;

  showSpinner: boolean = false;
  tabs?: Array<Tab>;

  exportType?: 'pdf' | 'excel';

  filteredData?: BgBomCategory[];
  filterText: string = '';

  selectedItemForPopup?: BgBomItem;
  selectedItemForGypsumPopup?: BgBomItem;
  gypsumSize: string = '4x8';
  gypsumSheets: number = 1;
  totalGypsumArea: number = 0;
  areaPerSheet: number = 32; // 4x8 by default
  isSetGypsumDisabled: boolean = false;
  gypsumWarningMessage: string = '';

  lumberLength: number = 8; // default length for lumber
  lumberQuantity?: number;
  isSetDisabled: boolean = false;
  quantityWarningMessage = 'Quantity must be a whole number';

  // get access to the table container
  @ViewChild('tableContainer') tableContainer?: ElementRef;


  constructor(
    private authService: AuthService,
    private excelService: ExcelService,
    private pdfService: PdfService,
    private bgModelService: BackendApiService,
    private bomCalculatorService: BomCalculatorService,
    private bomItemService: BomItemService,
    private modalService: NgbModal,
    private snackBar: MatSnackBar,
    private commercialOffersService: CommercialOffersService,
    config: NgbDropdownConfig,
    public router: Router
  ) {
    config.placement = 'bottom-end' as Placement;
  }

  get filteredGroupedSubCategories(): BgBomGroupedSubCategory[] | undefined {
    return this.bomItemService.getFilteredGroupedSubCategories(
      this.selectedCategory.value,
      this.filterText
    );
  }

  ngOnInit(): void {
    const sorted = this.data?.bgCategories?.sort(
      (a, b) => (a.order ?? 0) - (b.order ?? 0)
    );

    this.data?.bgCategories?.forEach((category) => this.bomItemService.setFlatIndex(category));

    this.sortedCategories = sorted;
    this.selectSubcategory(sorted?.[0]);
    this.tabs = this.bomItemService.categoriesToTabs(sorted, (category) => this.selectSubcategory(category));
  }

  selectSubcategory(selectedCategory?: BgBomCategory) {
    this.selectedCategory.next(selectedCategory);
    this.bomItemService.resetDuplicates();

    // Scroll Table to Top
    setTimeout(() => {
      if (this.tableContainer) {
        this.tableContainer.nativeElement.scrollTop = 0;
      }
    });
  }

  backToTable() {
    this.exportType = undefined;
  }

  exportTo(type: 'excel' | 'pdf', categories: Array<BgBomCategory>) {
    if (!this.model || !categories) return;

    switch (type) {
      case 'excel':
        this.exportToExcel(categories);
        break;
      case 'pdf':
        this.exportToPdf(categories, this.data?.modelName ?? '');
        break;
      default:
        throw new Error('Invalid export type');
    }
  }

  exportToExcel(tables?: Array<BgBomCategory>) {
    if (this.data?.modelName && tables && this.model) {
      this.excelService.exportModelToExcel(
        this.data.modelName,
        tables,
        this.model,
        this.authService.getClientName()
      );
      this.showSnackBar('BOM data exported to Excel successfully');
    }
  }

  openFileExplorer(): void {
    const folderId = this.data?.filesFolderId;
    if (!folderId) {
      this.showSnackBar('File explorer folder is not available', 'Close', 5000);
      return;
    }
    this.router.navigate(['/file-explorer', folderId]);
  }

  exportToPdf(tables?: Array<BgBomCategory>, modelName?: string) {
    if (this.data && tables) {
      new Promise(() => {
        if (this.data?.hasPrice) {
          this.pdfService.exportModelPriceToPdf(
            modelName,
            tables,
            this.model,
            this.authService.getClientName(),
            false
          );
        } else {
          this.pdfService.exportModelToPdf(
            modelName,
            tables,
            this.model,
            this.authService.getClientName(),
            true
          );
        }
        this.showSnackBar('BOM data exported to PDF successfully');
      });
    }
  }

  ToFileExplorer(type: 'CD' | 'SD'): void {
    let url: string | undefined;
    switch (type) {
      case 'CD':
        url = this.data?.cdFileUrl;
        break;
      case 'SD':
        url = this.data?.sdFileUrl;
        break;
      default:
        console.error('Invalid type specified');
        return;
    }

    if (!url || url.trim() === '') {
      this.showDocumentUnavailableDialog(type);
      return;
    }

    this.bgModelService.convertGoogleDriveFolderUrlToId(url).subscribe({
      next: (response) => {
        const folderId = response?.result;
        if (!folderId) {
          this.showDocumentUnavailableDialog(type);
          return;
        }

        this.router.navigate(['/file-explorer', folderId]);
        this.showSnackBar(`${type} folder opened in File Explorer`);
      },
      error: () => {
        this.showSnackBar('Unable to open File Explorer', 'Close', 5000);
      },
    });
  }

  /**
   * Opens a dialog informing the user that the requested document is unavailable
   * @param documentType The type of document that is unavailable (CD or SD)
   */
  private showDocumentUnavailableDialog(documentType?: string): void {
    const dialogRef = this.modalService.open(DocumentUnavailableDialogComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

    // Pass document type to the component if needed in the future
    if (dialogRef.componentInstance && documentType) {
      dialogRef.componentInstance.documentType = documentType;
    }
  }

  show3DView() {
    const url = `/view3d?model3dId=${this.data?.model3dId}&id=${this.data?.id}`;
    const title = `${this.data?.modelName} - 3D Viewer`;
    const w = 600;
    const h = 420;

    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(
      url,
      title,
      `menubar=0,location=0,toolbar=0,resizable=1,status=1,
      scrollbars=0,
      width=${w / systemZoom},
      height=${h / systemZoom},
      top=${top},
      left=${left}
      `
    );
    if (typeof window.focus === 'function') {
      newWindow?.focus();
    }
  }

  /**
   * Navigate to comparison page with current model and its previous version
   */
  compareWithPrevious() {
    if (!this.data?.id) {
      this.showSnackBar('Unable to compare: Model ID not available', 'Close', 5000);
      return;
    }

    const currentModelId = this.data.id;
    const previousModelId = `${currentModelId}_previous`;

    // Navigate to comparison page with both model IDs
    this.router.navigate(['/user/comparison'], {
      queryParams: {
        ids: `${currentModelId},${previousModelId}`
      }
    });
  }

  /**
   * Navigate to RFP list page, filtered by current model when available
   */
  navigateToRfpList() {
    if (this.data?.id) {
      this.router.navigate(['/user/rfp-requests', this.data.id]);
    } else {
      this.router.navigate(['/user/rfp-requests']);
    }
  }

  /**
   * Find the node description for the current model
   */
  private findNodeDescriptionForModel(modelId: string): string {
    const client = this.authService.getClientDataStructure();
    if (!client || !client.projectStructure) {
      return '';
    }

    // Recursively search for the model in the project structure
    const findModelInNodes = (nodes: any[]): string => {
      for (const node of nodes) {
        // Check if this node contains the model
        if (node.models) {
          const model = node.models.find((m: any) => m.id === modelId);
          if (model) {
            return node.description || '';
          }
        }

        // Recursively search child nodes
        if (node.nodes && node.nodes.length > 0) {
          const result = findModelInNodes(node.nodes);
          if (result) {
            return result;
          }
        }
      }
      return '';
    };

    return findModelInNodes(client.projectStructure);
  }

  /**
   * Create a new commercial offer for the current model
   */
  createNewCommercialOffer() {
    if (!this.data?.id) {
      this.showSnackBar('Unable to create commercial offer: Model ID not available', 'Close', 5000);
      return;
    }

    // Collect data for the header (you can add a form for TO/RE, or take the default ones)
    const modelName = this.data.modelName || '';
    const nodeDescription = this.findNodeDescriptionForModel(this.data.id) || '';
    const title = nodeDescription ? `${nodeDescription} - ${modelName}` : modelName;

    // TODO: Prompt the user for TO/RE or use default values
    const to = '';
    const re = '';

    setIsLoading(true);
    this.commercialOffersService.createEmptyCommercialOffer(this.data.id, { name: title, to, re }).subscribe({
      next: (response) => {
        setIsLoading(false);
        this.router.navigate(['/user/quotes/new'], {
          queryParams: {
            modelId: this.data!.id,
            modelName: modelName,
            nodeDescription: nodeDescription,
            title: title,
            data: JSON.stringify({ result: response })
          }
        });
        this.showSnackBar('Commercial offer created successfully');
      },
      error: (error) => {
        setIsLoading(false);
        console.error('Error creating commercial offer:', error);
        this.showSnackBar('Error creating commercial offer', 'Dismiss', 5000);
      }
    });
  }

  /**
   * Check if the user has permission to see the comparison button
   * Only admin and model exporter roles can see this button
   */
  canShowComparisonButton(): boolean {
    return this.authService.isAdmin() || this.authService.hasRoles('ModelExporter');
  }

  isDuplicate(
    item: BgBomItem,
    property: keyof BgBomItem,
    resetOnUnique: boolean = false
  ) {
    return this.bomItemService.isDuplicate(item, property, resetOnUnique);
  }

  resetDuplicates() {
    this.bomItemService.resetDuplicates();
  }

  isFraming() {
    return this.selectedCategory.value?.name?.toLowerCase() === 'framing';
  }

  addCustomLine(subcategory: BgBomSubCategory) {
    this.bomItemService.addCustomLine(subcategory);
    this.showSnackBar('Custom line added, please fill in the details');
  }

  saveCustomItem(item: BgBomItem, subcategory: BgBomSubCategory) {
    if (this.model?.id) {
      this.bomItemService.saveCustomItem(this.model.id, item, subcategory).subscribe(
        (result: any) => {
          if (this.selectedCategory.value) {
            this.bomItemService.setFlatIndex(this.selectedCategory.value);
          }
          item.id = result.bgBomItem.id;
          item.showLoader = false;
          this.showSnackBar('Custom item saved successfully');
        },
        (error) => {
          subcategory.bgBomItems.splice(
            subcategory.bgBomItems.indexOf(item),
            1
          );
          console.error(error);
          this.showSnackBar('Error saving custom item', 'Dismiss', 5000);
        }
      );
    }
  }

  deleteCustomItem(item: BgBomItem, subcategory: BgBomSubCategory) {
    item.showLoader = true;
    if (item.id && this.model?.id) {
      this.bomItemService.deleteCustomItem(this.model?.id, item).subscribe(
        (result) => {
          subcategory.bgBomItems.splice(
            subcategory.bgBomItems.indexOf(item),
            1
          );
          if (this.selectedCategory.value) {
            this.bomItemService.setFlatIndex(this.selectedCategory.value);
          }
          console.log(result);
          this.showSnackBar('Custom item deleted successfully');
        },
        (error) => {
          console.error(error);
          this.showSnackBar('Error deleting custom item', 'Dismiss', 5000);
        }
      );
    } else {
      subcategory.bgBomItems.splice(subcategory.bgBomItems.indexOf(item), 1);
    }
  }

  // LUMBER METHODS
  openLumberPopup(item: BgBomItem) {
    this.selectedItemForPopup = item;
    this.lumberLength = 8;
    this.recalculateLumber();
  }

  closeLumberPopup() {
    this.selectedItemForPopup = undefined;
  }

  // Helper method to get all items in the current subcategory
  private getCurrentSubcategoryItems(): BgBomItem[] {
    if (!this.selectedItemForPopup) return [];

    const subcategory = this.findSubcategoryForItem(this.selectedItemForPopup);
    return subcategory?.bgBomItems || [];
  }

  calculateLumber() {
    if (!this.selectedItemForPopup || !this.lumberLength || !this.lumberQuantity) {
      return;
    }
    const subcategory = this.findSubcategoryForItem(this.selectedItemForPopup);

    let parentItem : BgBomItem =  this.bomCalculatorService.findParentLumberItem(this.selectedItemForPopup, this.getCurrentSubcategoryItems()) ?? this.selectedItemForPopup;
    let totalLength = this.bomCalculatorService.calculateTotalLength(parentItem, this.getCurrentSubcategoryItems());

  let perentLength = this.bomCalculatorService.getParameterAsNumber(parentItem, 'length') * 1.1;
   let currentItemLength =  this.bomCalculatorService.getParameterAsNumber(this.selectedItemForPopup, this.bomCalculatorService.lumberLengthParam);
   let residueBomitem = this.bomCalculatorService.findChildTotalLumberResidue(this.selectedItemForPopup, this.getCurrentSubcategoryItems());
   let residueBomitemlength = 0;
   if (residueBomitem) {
        residueBomitemlength = this.bomCalculatorService.getParameterAsNumber(residueBomitem, this.bomCalculatorService.lumberLengthParam);
       if(this.selectedItemForPopup.itemBomType  ===  BomType.ChildTotalLumberResidue
        || String(this.selectedItemForPopup.itemBomType)  === BomType[BomType.ChildTotalLumberResidue]
        )
        {
          residueBomitemlength = 0;
        }
   }

    const totalLengthOfUser = this.lumberLength * this.lumberQuantity  ;



    let difference =   totalLengthOfUser  - residueBomitemlength - currentItemLength ;

     let size =  String(this.selectedItemForPopup.size).split(' x ')[0]

      if (difference <= 20 && difference >= -20) //if difference is less than 20 or greater than -20 is Equal  to 0
      {
        this.selectedItemForPopup.modelQuantity = String(Math.ceil(this.lumberQuantity * 0.9));
        this.selectedItemForPopup.quantityToOrder =  this.lumberQuantity ;

        this.selectedItemForPopup.size = size   + " x " + String(this.lumberLength) + "'-0\"";
        this.selectedItemForPopup.modelQuantityDescription =  'each' ;
        this.selectedItemForPopup.quantityToOrderDescription =  'each' + " - " + String(this.lumberLength)   + ' ' + 'ft';

        if(String(this.selectedItemForPopup.itemBomType)  === BomType[BomType.ChildTotalLumberResidue] ||
                  this.selectedItemForPopup.itemBomType  ===  BomType.ChildTotalLumberResidue )
          this.selectedItemForPopup.itemBomType = BomType.ChildTotalLumber;

        this.bomCalculatorService.setOrUpdateParameter(this.selectedItemForPopup, this.bomCalculatorService.lumberLengthParam, totalLengthOfUser.toString(), 'ft');
        this.bomCalculatorService.setOrUpdateParameter(this.selectedItemForPopup, this.bomCalculatorService.sizeLumberParam, this.lumberLength.toString() , 'ft');

       //delete residueBomitem
        let  residueBomitem = this.bomCalculatorService.findChildTotalLumberResidue(this.selectedItemForPopup, this.getCurrentSubcategoryItems());

        if (residueBomitem) {
          let index = subcategory?.bgBomItems.indexOf(residueBomitem);
          if (index === -1) {
            console.error('Could not find the selected item in the subcategory.');
            return;
          }
          if (index !== undefined) {
            subcategory?.bgBomItems.splice(index, 1);
          }
        }
      }
      else  {
        this.selectedItemForPopup.modelQuantity =   String(Math.ceil(this.lumberQuantity * 0.9)) ;
        this.selectedItemForPopup.quantityToOrder = String(this.lumberQuantity) ;
        //2x4 x 10'-0"
        this.selectedItemForPopup.size = size + " x " + String(this.lumberLength) + "'-0\"";
        this.selectedItemForPopup.modelQuantityDescription =  'each' ;
        this.selectedItemForPopup.quantityToOrderDescription =  'each' + " - " + String(this.lumberLength)   + ' ' + 'ft';

        if(String(this.selectedItemForPopup.itemBomType)  === BomType[BomType.ChildTotalLumberResidue] ||
                  this.selectedItemForPopup.itemBomType  ===  BomType.ChildTotalLumberResidue )
          this.selectedItemForPopup.itemBomType = BomType.ChildTotalLumber;

        this.bomCalculatorService.setOrUpdateParameter(this.selectedItemForPopup, this.bomCalculatorService.lumberLengthParam, totalLengthOfUser.toString(), 'ft');
        this.bomCalculatorService.setOrUpdateParameter(this.selectedItemForPopup, this.bomCalculatorService.sizeLumberParam, this.lumberLength.toString() , 'ft');

        let residueBomitem = this.bomCalculatorService.findChildTotalLumberResidue(this.selectedItemForPopup, this.getCurrentSubcategoryItems());

        // Find the subcategory that contains the selectedItemForPopup
        if (!subcategory) {
          console.error('Could not find subcategory for the selected item.');
          return;
        }

        if(residueBomitem){
          let residueBomitemlength = this.bomCalculatorService.getParameterAsNumber(residueBomitem, this.bomCalculatorService.lumberLengthParam);
          let fullLumberLength = this.bomCalculatorService.calculateTotalLength(parentItem, this.getCurrentSubcategoryItems());
          let difference = fullLumberLength  - perentLength - residueBomitemlength  ;
          let quantity = Math.ceil(difference * -1 );
           residueBomitem.modelQuantity = String(Math.ceil((quantity * 0.9)));
           residueBomitem.quantityToOrder =  quantity ;
           residueBomitem.modelQuantityDescription =  'lnft' ;
           residueBomitem.quantityToOrderDescription =  'lnft';
           this.bomCalculatorService.setOrUpdateParameter(residueBomitem, this.bomCalculatorService.lumberLengthParam, (difference * -1) .toString(), 'ft');
           this.bomCalculatorService.setOrUpdateParameter(this.selectedItemForPopup, this.bomCalculatorService.sizeLumberParam, this.lumberLength.toString() , 'ft');

        }
        else{

          const bomitemsGroup = subcategory?.bgBomItems.filter(i => i.parentId === parentItem.id  || i.id === parentItem.id);
          let bomitemWithMaxIndex = bomitemsGroup?.reduce((prev, current) => (prev.flatIndex ?? 0) > (current.flatIndex ?? 0) ? prev : current);
          let fullLumberLength = this.bomCalculatorService.calculateTotalLength(parentItem, this.getCurrentSubcategoryItems());

          let quantity = Math.ceil((fullLumberLength  - perentLength) * -1 );

           const newChild: BgBomItem = {
            id: undefined,
            parentId: parentItem.id ?? '',
            flatIndex : undefined,
            group: this.selectedItemForPopup.group,
            order: (this.selectedItemForPopup.order ?? 0),
            itemName: this.selectedItemForPopup.itemName,
            itemBomType: BomType.ChildTotalLumberResidue,
            size: size,
            manufacturer: this.selectedItemForPopup.manufacturer,
            manufacturerModel: this.selectedItemForPopup.manufacturerModel,
            modelQuantity: String(Math.ceil((quantity * 0.9))),
            modelQuantityDescription: "lnft",
            quantity: this.lumberQuantity,
            wasteFactor: this.selectedItemForPopup.wasteFactor,
            quantityToOrder: String(quantity),
            quantityToOrderDescription: "lnft",
            parameters: [ ],
            material: '', // Add appropriate value
            description: '' // Add appropriate value
          };


          this.bomCalculatorService.setOrUpdateParameter(newChild, this.bomCalculatorService.lumberLengthParam, ((fullLumberLength  - perentLength) * -1).toString(), 'ft');




          // Add the new item
          const index = subcategory.bgBomItems.indexOf(bomitemWithMaxIndex);
          if (index === -1) {
            console.error('Could not find the selected item in the subcategory.');
            return;
          }
          // Add the new item after the selectedItemForPopup
          subcategory.bgBomItems.splice(index + 1, 0, newChild);
        }
      }

       //get parent item BgBomSubCategory
        let  perentBgBomSubCategory = this.findSubcategoryForItem(parentItem);


        let isShowSnackBar = false;
        if(this.selectedItemForPopup.cost){
          this.selectedItemForPopup.cost = undefined;
          this.selectedItemForPopup.totalCost = undefined;
          isShowSnackBar = true;
        }


    this.closeLumberPopup();
    if(perentBgBomSubCategory)
    this.onSaveChanges(perentBgBomSubCategory);

    if(isShowSnackBar)
    this.showSnackBar('Lumber calculation applied successfully, Reload the page to see the cost');


  }

  deleteLumberItem(item: BgBomItem) {
    const subcategory = this.findSubcategoryForItem(item);
    if (!subcategory) return;

    // Get all items from the current subcategory
    const categoryItems = subcategory.bgBomItems;

    // Use the service to handle lumber item deletion
    const result = this.bomCalculatorService.deleteLumberItem(item, categoryItems);

    // Remove the item to delete
    const index = subcategory.bgBomItems.indexOf(result.itemToDelete);
    if (index !== -1) {
      subcategory.bgBomItems.splice(index, 1);
    }

    // Add new residue item if needed
    if (result.newResidueItem) {
      const parentItem = this.bomCalculatorService.findParentLumberItem(item, categoryItems) || item;

      // Find the max index item in the group to position the new item after it
      const groupItems = categoryItems.filter(i => i.parentId === parentItem.id || i.id === parentItem.id);
      const maxIndexItem = groupItems.reduce(
        (prev, current) => (prev.flatIndex ?? 0) > (current.flatIndex ?? 0) ? prev : current,
        groupItems[0]
      );

      // Add the new item after the max index item
      const maxIndex = subcategory.bgBomItems.indexOf(maxIndexItem);
      if (maxIndex !== -1) {
        subcategory.bgBomItems.splice(maxIndex + 1, 0, result.newResidueItem);
      }
    }

    this.onSaveChanges(subcategory);
   }

  resetTotalSettings(parent: BgBomItem) {
    const subcategory = this.findSubcategoryForItem(parent);
    if (!subcategory) return;

    // Remove all children
    const children = subcategory.bgBomItems.filter(i => i.parentId === parent.id);
    for (const child of children) {
      const index = subcategory.bgBomItems.indexOf(child);
      if (index !== -1) {
        subcategory.bgBomItems.splice(index, 1);
      }
    }

    // Reset parent to default values
    this.bomCalculatorService.resetTotalSettings(parent);

    this.onSaveChanges(subcategory);
  }

  isTotalLumber(item: BgBomItem): boolean {
    return this.bomCalculatorService.isTotalLumber(item);
  }

  isTotalLumberWithChildren(item: BgBomItem): boolean {
    const subcategory = this.findSubcategoryForItem(item);
    if (!subcategory) return false;

    return this.bomCalculatorService.isTotalLumberWithChildren(item, subcategory.bgBomItems);
  }

  isChildTotalLumber(item: BgBomItem): boolean {
    return this.bomCalculatorService.isChildTotalLumber(item);
  }

  recalculateLumber() {
    if (this.lumberLength && this.selectedItemForPopup) {
      const categoryItems = this.getCurrentSubcategoryItems();

      // Calculate total length
      const totalLength = this.bomCalculatorService.calculateTotalLength(
        this.selectedItemForPopup,
        categoryItems
      );

      // Get the current item's length
      let itemLength = this.bomCalculatorService.getParameterAsNumber(
        this.selectedItemForPopup,
        'lumberLengthParam'
      );

      // Check for residue
      let residueItem = this.bomCalculatorService.findChildTotalLumberResidue(
        this.selectedItemForPopup,
        categoryItems
      );

      let maxLength = 0;

      if (residueItem) {
        if (this.selectedItemForPopup.itemBomType === BomType.ChildTotalLumberResidue ||
            String(this.selectedItemForPopup.itemBomType) === BomType[BomType.ChildTotalLumberResidue]) {
          maxLength = this.bomCalculatorService.getParameterAsNumber(residueItem, 'lumberLengthParam');
        } else {
          maxLength = this.bomCalculatorService.getParameterAsNumber(residueItem, 'lumberLengthParam');
          maxLength += itemLength;
        }
      } else {
        let parentItem = this.bomCalculatorService.findParentLumberItem(
          this.selectedItemForPopup,
          categoryItems
        ) || this.selectedItemForPopup;

        maxLength = this.bomCalculatorService.getParameterAsNumber(parentItem, 'lumberLengthParam');
      }

      // Calculate quantity based on max length and selected length
      this.lumberQuantity = maxLength / this.lumberLength;
      this.lumberQuantity = Math.ceil(this.lumberQuantity);

      this.checkInputLangthLumberValue();
    }
  }

  onLengthInputChange() {
    // Round to the nearest even number
    const remainder = this.lumberLength ?? 0 % 2;
    if (remainder !== 0) {
      if (remainder < 1) {
        this.lumberLength = this.lumberLength ?? 0 - remainder; // round down
      } else {
        this.lumberLength = this.lumberLength ?? 0 + (2 - remainder); // round up
      }
    }

    this.checkInputLangthLumberValue();
  }

  checkInputLangthLumberValue() {
    if (!this.lumberLength || !this.selectedItemForPopup) return;

    const categoryItems = this.getCurrentSubcategoryItems();
    let totalInput = (this.lumberLength ?? 1) * (this.lumberQuantity ?? 1);

    // Calculate max length
    let itemLength = this.bomCalculatorService.getParameterAsNumber(
      this.selectedItemForPopup,
      'lumberLengthParam'
    );

    let residueItem = this.bomCalculatorService.findChildTotalLumberResidue(
      this.selectedItemForPopup,
      categoryItems
    );

    let maxLength = 0;

    if (residueItem) {
      if (String(this.selectedItemForPopup.itemBomType) === BomType[BomType.ChildTotalLumberResidue] ||
          this.selectedItemForPopup.itemBomType === BomType.ChildTotalLumberResidue) {
        maxLength = this.bomCalculatorService.getParameterAsNumber(residueItem, 'lumberLengthParam');
      } else {
        maxLength = this.bomCalculatorService.getParameterAsNumber(residueItem, 'lumberLengthParam');
        maxLength += itemLength;
      }
    } else {
      let parentItem = this.bomCalculatorService.findParentLumberItem(
        this.selectedItemForPopup,
        categoryItems
      ) || this.selectedItemForPopup;

      maxLength = this.bomCalculatorService.getParameterAsNumber(parentItem, 'lumberLengthParam');
    }

    // Check constraints
    this.isSetDisabled = this.lumberLength > 24;
    if (this.isSetDisabled) {
      this.quantityWarningMessage = 'Length is too high, Please enter a length between 8 and 24';
      return;
    }

    this.isSetDisabled = this.lumberLength < 8;
    if (this.isSetDisabled) {
      this.quantityWarningMessage = 'Length is too low, Please enter a length between 8 and 24';
      return;
    }

    this.isSetDisabled = !Number.isInteger(this.lumberQuantity);
    if (this.isSetDisabled) {
      this.quantityWarningMessage = 'Quantity must be a whole number';
      return;
    }

    this.isSetDisabled = (this.lumberQuantity ?? 0) < 1;
    if (this.isSetDisabled) {
      this.quantityWarningMessage = 'Quantity must be greater than 0';
      return;
    }

    this.isSetDisabled = totalInput > maxLength;

    // Check if lumber with same section already exists
    this.isSetDisabled = this.bomCalculatorService.containsLumberWithSameSection(
      this.selectedItemForPopup,
      this.lumberLength,
      categoryItems
    );

    if (this.isSetDisabled) {
      this.quantityWarningMessage = 'Lumber with the same length already exists';
      return;
    }

    this.isSetDisabled = totalInput - maxLength > 24;
    if (this.isSetDisabled) {
      this.quantityWarningMessage = 'Quantity is too high';
    }
  }

  // GYPSUM BOARD METHODS
  isTotalGypsumBoard(item: BgBomItem): boolean {
    return this.bomCalculatorService.isTotalGypsumBoard(item);
  }

  isGypsumBoard(item: BgBomItem): boolean {
    return this.bomCalculatorService.isGypsumBoard(item);
  }

  /**
   * Event handler for gypsum size dropdown change
   */
  onGypsumSizeDropdownChange(item: BgBomItem, event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.onGypsumSizeChange(item, selectElement.value);
  }

  /**
   * Handles size changes for gypsum board items
   *
   * @param item The BOM item being changed
   * @param optionSize The selected size option
   */
  onGypsumSizeChange(item: BgBomItem, optionSize: string): void {
    //get sheet area by dictionary
    const entry = Object.entries(SheetSizesDictionary).find(([key, value]) => value === optionSize);
    let sheetArea: number = entry ? Number(entry[0]) : 32;

    const thickness = this.bomCalculatorService.getParameterAsString(item, 'thickness');
    const itemSheetSize = this.bomCalculatorService.getParameterAsNumber(item, 'sheetSize');
    let totalBomItemsSameSize ;
    //remove cost after change size
    if(item.cost)
      {
        item.cost  = undefined;
        item.totalCost = undefined;
      }



    //Need for search a total item (sum of Gypsum Board) . A total Gypsum Board location always in the same group
    //a category divide by groups (by defult  groups is Levels) .
    const group = this.bomItemService.findGroupedSubcategoryForItem(item, this.selectedCategory.value)
    if(!group)
      return

    //a Total item  for  remove  area
      totalBomItemsSameSize = this.GetTotalGBItem(group, itemSheetSize, thickness, item.itemName ?? '');

    // Recalculate sheets
    const { area, gypsumSheets } = this.UpdateCurrentItem(item, sheetArea);

    //a Total item  for  add  area
    let newTotalBomItem  = this.GetTotalGBItem(group,sheetArea, thickness, item.itemName ?? '')

    let  subcategory = group?.bgSubCategories?.find(sub => sub.name.toLowerCase().includes("total"));

    //Create new  if there is not  a total item  for add
    if(newTotalBomItem.length === 0)
    {
       const newTotalItem: BgBomItem = this.createNewTotalGypsumBoard(item, optionSize, area, gypsumSheets, sheetArea, thickness);
      if (subcategory)
          subcategory.bgBomItems.push(newTotalItem);

      this.showSnackBar(`Gypsum board size changed to ${optionSize}, Reload the page to see the cost`);
    }
    else
    {
       let   updatingTotalBomItem : BgBomItem | undefined  = newTotalBomItem[0]
      if (updatingTotalBomItem) {
        if(updatingTotalBomItem.cost)
        {

          this.showSnackBar("Successfully updated the total item, Reload the page to see the cost");
        }
           this.UpdatNewNumberTotal(updatingTotalBomItem, area, sheetArea);
      }
    }
       const oldItem: BgBomItem | undefined = totalBomItemsSameSize[0];
       if(oldItem) {

        const oldarea = this.bomCalculatorService.getParameterAsNumber(oldItem,'area');
        const updatedOldItemArea = oldarea - area;

        if(updatedOldItemArea < 50) //One sheet  +/-
        {
          //remove  the bomItem from subcategory
          if (subcategory) {
            const index = subcategory.bgBomItems.indexOf(oldItem);
            if (index > -1) {
              subcategory.bgBomItems.splice(index, 1);
            }
          }
        }
        else
        {
          this.UpdateOldTotalItem(oldItem, updatedOldItemArea, itemSheetSize);
        }

      }

    // Save changes to the backend
    const itemSubcategory = this.findSubcategoryForItem(item);
    if (itemSubcategory && subcategory) {
      this.onSaveChanges(itemSubcategory);

      this.onSaveChanges(subcategory);
    }
  }

  private UpdateOldTotalItem(oldItem: BgBomItem, updatedOldItemArea: number, itemSheetSize: number) {
    const wasteFactory = this.bomCalculatorService.getParameterAsNumber(oldItem, 'wasteFactor');
    oldItem.modelQuantity = Math.ceil(updatedOldItemArea).toString();
    oldItem.quantityToOrder = Math.ceil(updatedOldItemArea / itemSheetSize * ((wasteFactory / 100) + 1)).toString();

    //remove cost
    oldItem.cost  = undefined;
    oldItem.totalCost = undefined;
    // Update old total parameters
    this.bomCalculatorService.setOrUpdateParameter(oldItem, 'area', updatedOldItemArea.toString(), 'sqft');
    this.bomCalculatorService.setOrUpdateParameter(oldItem, 'sheets', oldItem.quantityToOrder, 'sheets');
  }

  private UpdatNewNumberTotal(updatingTotalBomItem: BgBomItem, area: number, sheetArea: number) {
    const currentArea = this.bomCalculatorService.getParameterAsNumber(updatingTotalBomItem, 'area');
    const newArea = currentArea + area;

    const wasteFactor = this.bomCalculatorService.getParameterAsNumber(updatingTotalBomItem, 'wasteFactor');
    updatingTotalBomItem.modelQuantity = Math.ceil(newArea).toString();
    let sheets = newArea / sheetArea
    updatingTotalBomItem.quantityToOrder = Math.ceil(sheets + (sheets * wasteFactor / 100)).toString();
//remove cost
    updatingTotalBomItem.cost  = undefined;
    updatingTotalBomItem.totalCost = undefined;


    // Update total parameters
    this.bomCalculatorService.setOrUpdateParameter(updatingTotalBomItem, 'area', newArea.toString(), 'sqft');
    this.bomCalculatorService.setOrUpdateParameter(updatingTotalBomItem, 'sheets', updatingTotalBomItem.quantityToOrder, 'sheets');
    return newArea;
  }

  private GetTotalGBItem(group: BgBomGroupedSubCategory,   itemSheetSize: number, thickness: string, name: string) {
    const totalBomItems = group.bgSubCategories?.flatMap(sub => sub.bgBomItems) ?? [];
    const gypsumTotalItems = totalBomItems.filter(item => this.bomCalculatorService.isTotalGypsumBoard(item));

    //get total sheets size
   let totalBomItemsSameSize = gypsumTotalItems.filter(totalItem => {
      const totalSheetSize = this.bomCalculatorService.getParameterAsNumber(totalItem, 'sheetSize');
      const totalLayerWidth = this.bomCalculatorService.getParameterAsString(totalItem, 'thickness');
      return totalSheetSize === itemSheetSize && totalLayerWidth === thickness && totalItem.itemName === name;
    });
    return totalBomItemsSameSize;
  }

  private UpdateCurrentItem(item: BgBomItem, sheetArea: number) {
    const area = this.bomCalculatorService.getParameterAsNumber(item, 'area');
    let wasteFactor = this.bomCalculatorService.getParameterAsNumber(item, 'wasteFactor');
    this.bomCalculatorService.setOrUpdateParameterNumber(item,"sheetSize" , sheetArea )
    const sheets = area / sheetArea;
    if (wasteFactor === 0) { wasteFactor = 1; }
    const gypsumSheets = Math.ceil(sheets + (sheets * wasteFactor / 100));
    item.quantityToOrder = gypsumSheets.toString();
    return { area, gypsumSheets };
  }

  private createNewTotalGypsumBoard(item: BgBomItem, optionSize: string, area: number, gypsumSheets: number, sheetArea: number, thickness: string) {
    const newTotalItem: BgBomItem = {
      id: undefined,
      flatIndex: undefined,
      group: item.group,
      order: (item.order ?? 0) + 0.1,
      itemName: item.itemName,
      itemBomType: BomType.GypsumBoardTotal,
      size: item.size + " x " + optionSize,
      manufacturer: item.manufacturer,
      manufacturerModel: item.manufacturerModel,
      modelQuantity: Math.ceil(area).toString(),
      modelQuantityDescription: "sqft",
      quantity: gypsumSheets,
      wasteFactor: item.wasteFactor,
      quantityToOrder: gypsumSheets.toString(),
      quantityToOrderDescription: "sheets",
      parameters: [],
      material: '',
      description: ''
    };

    let wf = this.bomCalculatorService.getParameterAsNumber(item,  "wasteFactor");

    // Add parameters to track sheet size and count
    this.bomCalculatorService.setOrUpdateParameter(newTotalItem, 'sheetSize', sheetArea.toString(), 'sqft');
    this.bomCalculatorService.setOrUpdateParameter(newTotalItem, 'sheets', gypsumSheets.toString(), 'sheets');
    this.bomCalculatorService.setOrUpdateParameter(newTotalItem, 'area', area.toString(), 'sqft');
    this.bomCalculatorService.setOrUpdateParameter(newTotalItem, 'thickness', thickness.toString(), 'ft');
    this.bomCalculatorService.setOrUpdateParameter(newTotalItem, 'wasteFactor', wf.toString(), '%');
    return newTotalItem;
  }

  getGypsumSheetsSize(item: BgBomItem) {
    let sheetSize = this.bomCalculatorService.getParameterAsNumber(item, 'sheetSize');
    if(sheetSize === 0) { sheetSize = 32; } // Default to 4x8
   //get by dictionary
   return SheetSizesDictionary[sheetSize as keyof typeof SheetSizesDictionary];
  }

  onGypsumSheetsInputChange() {
    // Check constraints when user edits the sheets input
    this.checkGypsumConstraints();
  }

  private checkGypsumConstraints() {
    this.isSetGypsumDisabled = false;
    this.gypsumWarningMessage = '';

    // Must have at least 1 sheet
    if (this.gypsumSheets < 1) {
      this.isSetGypsumDisabled = true;
      this.gypsumWarningMessage = 'Number of sheets must be >= 1.';
      return;
    }

    // Only integers allowed
    if (!Number.isInteger(this.gypsumSheets)) {
      this.isSetGypsumDisabled = true;
      this.gypsumWarningMessage = 'Sheets must be a whole number.';
      return;
    }
  }

  applyGypsumChanges() {
    if (!this.selectedItemForGypsumPopup) return;

    // Use the service to apply changes
    this.bomCalculatorService.applyGypsumChanges(
      this.selectedItemForGypsumPopup,
      this.gypsumSize,
      this.gypsumSheets,
      this.totalGypsumArea
    );

    // Save changes
    const subcategory = this.findSubcategoryForItem(this.selectedItemForGypsumPopup);
    if (subcategory) {
      this.onSaveChanges(subcategory);
    }

    this.closeGypsumPopup();
  }

  closeGypsumPopup() {
    this.selectedItemForGypsumPopup = undefined;
  }

  /**
   * Finds the subcategory that contains the given item.
   */
  private findSubcategoryForItem(item: BgBomItem): BgBomSubCategory | undefined {
    return this.bomItemService.findSubcategoryForItem(item, this.selectedCategory.value);
  }

  public trackByGroupedSubcategory(index: number, item: BgBomGroupedSubCategory): string {
    return item.name || '' ; // Use a unique identifier
  }

  public trackBySubcategory(index: number, item: BgBomSubCategory): string {
    return item.name || ''; // Use a unique identifier
  }

  public trackByItem(index: number, item: BgBomItem): string {
    return item.id || ''; // Use a unique identifier
  }

  onSaveChanges(subcategory: BgBomSubCategory) {
    if (this.data) {
      this.bomCalculatorService.saveChanges(subcategory, this.data.id ?? '').subscribe({
        next: (response) => {
          console.log('Update successful', response);

          // Reset flat index for selected category after save
          if (this.selectedCategory.value) {
            this.bomItemService.setFlatIndex(this.selectedCategory.value);
          }
        },
        error: (err) => {
          console.error('Error updating model', err);
          this.showSnackBar('Error saving BOM data', 'Dismiss', 5000);
        },
      });
    }
  }

  /**
   * Displays a snack bar notification
   * @param message The message to display
   * @param action Text for the action button
   * @param duration Duration in milliseconds
   */
  showSnackBar(message: string, action: string = 'Close', duration: number = 5000): void {
    this.snackBar.open(message, action, {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['snackbar']

    });
  }

  hasQuotesPermission(): boolean {
    return this.authService.hasServicePermission('Quotes');
  }

  isBomTypeAddon(item: BgBomItem): boolean {
    return item.itemBomType?.toString() === 'Addon' || item.itemBomType === BomType.Addon;
  }
}
